import { ColumnDataType, TableColumn } from "@cotecna/tables";

export const DOCUMENTS_TABLE_COLUMNS: TableColumn[] = [
  {
    dataProperty: "name",
    isSorting: true,
    label: "Document",
    dataType: ColumnDataType.String,
    width: 60,
    widthInPercentage: true,
  },
  {
    dataProperty: "documentTypeName",
    isSorting: true,
    label: "Document Type",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "creationDateUtc",
    isSorting: true,
    label: "Creation date",
    dataType: ColumnDataType.Date,
    width: 0,
  },
  {
    dataProperty: "createdBy",
    isSorting: true,
    label: "Created by",
    dataType: ColumnDataType.String,
    width: 0,
  },
];
